import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import DynamicList from 'components/list/DynamicList';
import { FilterType } from 'components/list/DynamicListFilterUtils';

import { ADMIN } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

const MissingMappingStatusesGroupedList = () => {
	const columns = useMemo(() => [
		{
			Header: 'deliveryCompanyID',
			accessor: 'deliveryCompanyId',
			filterType: FilterType.number
		},
		{
			Header: 'deliveryCompanyName',
			accessor: 'deliveryCompanyName',
			filterType: FilterType.string
		},
		{
			Header: 'dcStatus',
			accessor: 'dcStatus',
			filterType: FilterType.string
		},
		{
			Header: 'numberOfRecords',
			accessor: 'numberOfRecords',
			filterType: FilterType.number
		},
		{
			Header: 'integrationName',
			accessor: 'integrationName',
			filterType: FilterType.string
		},
		{
			Header: 'statusIntegrationName',
			accessor: 'statusIntegrationName',
			filterType: FilterType.string
		}
	]);

	const defaultSort = useMemo(() => [{ id: 'numberOfRecords', desc: true }], []);

	return (
		<div>
			<DynamicList
				id={DYNAMICLISTS.MISSING_MAPPING_STATUSES_GROUPED}
				columns={columns}
				fetchUrl={ADMIN.STATUS_MANAGEMENT.GET_MISSING_STATUS_MAPPING_GROUPED_LIST}
				actionObjectType={ACTION_OBJECT_TYPES.ADMIN}
				defaultSort={defaultSort}
				exportName="MissingMappingStatusesGrouped"
			/>
		</div>
	);
};

export default MissingMappingStatusesGroupedList;
